import React from 'react'
import styled from 'styled-components'
import * as R from 'ramda'
import 'loaders.css/loaders.min.css'

const Outer = styled.div.attrs({
  className: 'loader',
})``

const Inner = styled.div.attrs({
  className: 'loader-inner',
})`
  & > div {
    background-color: orange !important;
  }
`

const elementCounts = {
  pacman: 5,
  'ball-pulse': 3,
}

export const Loader = ({ name, elementCount }) => {
  if (typeof elementCount === 'undefined') {
    elementCount = elementCounts[name]
  }

  console.log('rendering loader')

  const elements = R.times(n => <div key={n} />, elementCount)

  console.log(elements)

  return (
    <Outer>
      <Inner className={name}>{elements}</Inner>
    </Outer>
  )
}



// WEBPACK FOOTER //
// ./src/elements/Loader.js